import React from 'react';
import { Spinner, Stack, StackItem, Text, TextContent } from '@patternfly/react-core';
import { ExternalLinkAltIcon } from '@patternfly/react-icons';
import { RegressionTestSuiteSelection } from './RegressionTestSuiteSelector';
import { SuiteTriggerState } from './DeployStep';

interface TestingStepProps {
  selections: Record<string, RegressionTestSuiteSelection>;
  results: Record<string, SuiteTriggerState>;
}

export const TestingStep: React.FC<TestingStepProps> = ({ selections, results }) => {
  const enabledSuiteKeys = Object.entries(selections)
    .filter(([, s]) => s.enabled)
    .map(([key]) => key);

  if (enabledSuiteKeys.length === 0) {
    return (
      <TextContent>
        <Text>No regression suites were selected.</Text>
      </TextContent>
    );
  }

  return (
    <Stack hasGutter>
      <StackItem>
        <TextContent>
          <Text component="h3">Regression Tests</Text>
          <Text>Suites selected in Configure are triggered automatically once the preview deploy succeeds.</Text>
        </TextContent>
      </StackItem>
      {enabledSuiteKeys.map((suiteKey) => {
        const state = results[suiteKey];
        return (
          <StackItem key={suiteKey}>
            <TextContent>
              <Text component="p">
                <strong>{suiteKey.replace(/_/g, ' ')}</strong>
                {(!state || state.status === 'triggering') && <Spinner size="sm" style={{ marginLeft: 8 }} />}
                {(state?.status === 'triggered' || state?.status === 'queued') && (
                  <span style={{ marginLeft: 8, fontSize: 13 }}>
                    Triggered
                    {state.status === 'triggered' && (
                      <>
                        {' — '}
                        <a href={state.jobUrl} target="_blank" rel="noreferrer">
                          View in Jenkins <ExternalLinkAltIcon />
                        </a>
                      </>
                    )}
                  </span>
                )}
                {state?.status === 'error' && (
                  <span style={{ marginLeft: 8, fontSize: 13, color: '#BF2600' }}>{state.message}</span>
                )}
              </Text>
            </TextContent>
          </StackItem>
        );
      })}
    </Stack>
  );
};
